module.exports = __webpack_public_path__ + "img/oral_contraception_pillsx28.adedeb1f.svg";